import axios from "./axiosInstance";

const facultyAPI ={ 
   faculty : () => axios.get("our-faculty"),
   career : () => axios.get("career"),
   faculty_join : () => axios.get("join-faculty"),
   career_form : (data) => axios.post("career-form", data),
    
}

export default facultyAPI;